/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="83.41"
        height="95.61"
        viewBox="0 0 83.41 95.61"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M82.1 8.55a1.25 1.25 0 0 1 1.31 1.19 1.24 1.24 0 0 1-1.18 1.31h-81A1.25 1.25 0 0 1 0 9.78a1.27 1.27 0 0 1 1.1-1.22h81Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M76.15 8.55a1.26 1.26 0 0 1 1.29 1.12V62.5a2.45 2.45 0 0 1-2.29 2.43H8.35a2.44 2.44 0 0 1-2.45-2.28V9.8a1.26 1.26 0 0 1 1.2-1.33 1.27 1.27 0 0 1 1.34 1.2V62.5h66.47V9.8a1.24 1.24 0 0 1 1.12-1.24Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M53.02 62.71a1.27 1.27 0 0 1 1.57.58l.06.11 12.31 30.39a1.25 1.25 0 0 1-2.26 1.06l-.06-.12-12.31-30.34a1.25 1.25 0 0 1 .68-1.63ZM28.52 63.39a1.25 1.25 0 0 1 2.36.82v.18L18.5 94.86a1.25 1.25 0 0 1-2.36-.82v-.12ZM41.64 0a1.26 1.26 0 0 1 1.25 1.12V9.8a1.27 1.27 0 0 1-1.28 1.23 1.25 1.25 0 0 1-1.21-1.1V1.25A1.25 1.25 0 0 1 41.64 0ZM41.64 62.5a1.26 1.26 0 0 1 1.25 1.12v30.69a1.27 1.27 0 0 1-1.28 1.23 1.25 1.25 0 0 1-1.21-1.1V63.7a1.25 1.25 0 0 1 1.24-1.2Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M44.61 33.93h14.23A15 15 0 0 0 44.61 19.7Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="M44.65 18.95a.75.75 0 0 0-.79.71v14.27a.74.74 0 0 0 .75.75h14.23a.75.75 0 0 0 .75-.75 15.75 15.75 0 0 0-14.94-14.98Zm.71 1.55h.19A14.27 14.27 0 0 1 58.01 33v.18H45.36Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M38.64 24.18a15 15 0 1 0 15.7 15.71h-15a.73.73 0 0 1-.73-.74Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="M38.6 23.39a15.74 15.74 0 1 0 16.49 16.5v-.1a.75.75 0 0 0-.75-.69h-14.9v-15a.77.77 0 0 0-.81-.71Zm-.69 1.6V39.3a1.48 1.48 0 0 0 1.48 1.34h14.16v.16a14.24 14.24 0 1 1-15.8-15.79Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'ProjectorScreenWithPieChartIcon';

export default Icon;
